// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";
import { claimStateSchema, dateSchema } from "../commonSchemas";

export const path = "get-claims";

export const getClaimsParamsSchema = z.object({
  accountType: z.string().optional(),
});

export const claimHistoryItemSchema = z.object({
  id: z.string(),
  createdAt: dateSchema,
  message: z.string(),
  createdBy: z.string(),
});

export const loadSchema = z.object({
  id: z.string(),
  name: z.string(),
  source: z.string(),
  destination: z.string(),
  carrierName: z.string().optional(),
  pickupStart: dateSchema.optional(),
  pickupEnd: dateSchema.optional(),
  deliveryStart: dateSchema.optional(),
  deliveryEnd: dateSchema.optional(),
});

export const claimSchema = z.object({
  id: z.string(),
  state: claimStateSchema,
  submittedTo: z.string().nullable(),
  createdAt: dateSchema,
  updatedAt: dateSchema,
  createdBy: z.string(),
  claimAmount: z.number(),
  detailsHistory: z.array(claimHistoryItemSchema),
  load: loadSchema,
});

export const getClaimsResponseSchema = z.array(claimSchema);




export type GetClaimsParams = z.infer<typeof getClaimsParamsSchema>;

export type ClaimHistoryItem = z.infer<typeof claimHistoryItemSchema>;

export type Claim = z.infer<typeof claimSchema>;

export type GetClaimsResponse = z.infer<typeof getClaimsResponseSchema>;




// receiver/get-claims endpoint
export function getClaims(
  params: z.input<typeof getClaimsParamsSchema>
): Promise<GetClaimsResponse> {
  return requestHandler(
    "receiver/get-claims",
    params,
    getClaimsResponseSchema,
  );
}

